import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import styles from "../../styles";
var SendMessageButton = function (props) {
    var t = useTranslation(["chat"]).t;
    return (_jsx("div", { className: "d-flex align-items-center", style: styles.buttonWrapper, children: _jsx("button", { className: "btn btn-primary compact", onClick: function () { return props.onClick(); }, children: t("Send") }) }));
};
export default SendMessageButton;
